<template>
    <base-spinner v-if="isLoading"></base-spinner>
    <div class="main">
        <div v-if="!!error" class="notification is-danger">
            <p>{{ error }}</p>
        </div>
        <EventItem v-for="event in events" :key="event.id" :id="event.id" :name="event.name" :date="event.date"></EventItem>
    </div>
</template>

<script>
import EventItem from '@/components/events/EventItem';

export default {
    components: {
        EventItem
    },
    created() {
        this.loadEvents()
    },
    data() {
        return {
            isLoading: false,
            error: null
        }
    },
    computed: {
        events() {
            return this.$store.getters['events/getEvents'];
        }
    },
    methods: {
        async loadEvents() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('events/loadEvents');
            } catch (error) {
                this.error = error.message || 'Something failed!';
                console.error(error.message);
            }
            this.isLoading = false;
        }
    }
}
</script>